module.exports = __webpack_public_path__ + "static/media/sc7.11.5319cbf0.mp4";